<template>
  <div class="tab">
    <!-- RN-12: el avance del plan no se captura, se deriva de aquí. -->
    <div class="cabecera">
      <div>
        <div class="avance-num">{{ Math.round(plan.avance || 0) }}%</div>
        <div class="avance-lbl">
          Avance del plan · promedio de {{ activas.length }} actividad(es)
        </div>
      </div>
      <div class="avance-track">
        <div class="avance-fill" :style="{ width: (plan.avance || 0) + '%' }"></div>
      </div>
    </div>

    <table v-if="plan.tareas.length" class="tabla">
      <thead>
        <tr>
          <th>Actividad</th>
          <th>Responsable</th>
          <th>Compromiso</th>
          <th class="th-av">Avance</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="t in plan.tareas" :key="t.idTarea">
          <td>
            <div class="t-titulo" :class="{ hecha: t.estatus === 'concluida' }">
              {{ t.titulo }}
            </div>
            <div v-if="t.descripcion" class="t-desc">{{ t.descripcion }}</div>
            <div class="t-est">{{ etiquetaTarea(t.estatus) }}</div>
          </td>
          <td class="t-resp">{{ t.responsable || "—" }}</td>
          <td class="t-fecha">
            {{ fmtFecha(t.fechaCompromiso) }}
            <div v-if="t.fechaConclusion" class="t-fin">
              concluida {{ fmtFecha(t.fechaConclusion) }}
            </div>
          </td>
          <td class="td-av">
            <select
              v-if="editable"
              class="av-sel"
              :value="Math.round(t.avance || 0)"
              :disabled="guardando === t.idTarea"
              @change="cambiar(t, $event.target.value)"
            >
              <option v-for="n in OPCIONES" :key="n" :value="n">{{ n }}%</option>
            </select>
            <span v-else class="av-fijo">{{ Math.round(t.avance || 0) }}%</span>
          </td>
        </tr>
      </tbody>
    </table>

    <p v-else class="vacio">
      Este plan aún no tiene actividades. Desglosar el trabajo es lo que permite
      medir el avance.
    </p>

    <!-- Cuando el formulario está oculto, decir POR QUÉ. Antes solo desaparecía
         y el vacío no distinguía "no hay nada capturado" de "todavía no te toca
         capturar". Es la misma idea que la pestaña Validación: enumerar lo que
         falta, en vez de dejar un hueco silencioso. -->
    <p v-if="bloqueo" class="bloqueo">
      <strong>Aún no se pueden capturar actividades.</strong> {{ bloqueo }}
    </p>

    <!-- Alta de actividad -->
    <div v-if="editable" class="alta">
      <div class="alta-titulo">Nueva actividad</div>
      <div class="alta-grid">
        <label class="field campo-ancho">
          <span class="field-label">Qué hay que hacer</span>
          <input v-model="f.titulo" class="inp" placeholder="Describe la actividad" />
          <span v-if="errores.titulo" class="field-error">{{ errores.titulo }}</span>
        </label>
        <label class="field">
          <span class="field-label">Fecha compromiso</span>
          <input v-model="f.fechaCompromiso" type="date" class="inp" />
          <span v-if="errores.fechaCompromiso" class="field-error">
            {{ errores.fechaCompromiso }}
          </span>
        </label>
        <button
          class="btn-add"
          :disabled="agregando"
          :style="{ background: agregando ? '#cbd5e1' : '#003ca5' }"
          @click="agregar"
        >
          {{ agregando ? "Agregando…" : "Agregar" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { fmtFecha } from "../cx.rules";
import { validaTarea } from "../cx.validators";

const ETIQUETAS = {
  pendiente: "Pendiente",
  en_proceso: "En proceso",
  bloqueada: "Bloqueada",
  en_revision: "En revisión",
  concluida: "Concluida",
  cancelada: "Cancelada",
};

export default {
  name: "TabActividades",
  props: {
    plan: { type: Object, required: true },
    editable: { type: Boolean, default: false },
    agregando: { type: Boolean, default: false },
    guardando: { type: [Number, String], default: null },
  },
  emits: ["agregar-tarea", "avance-tarea"],
  data() {
    return {
      OPCIONES: [0, 10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 100],
      errores: {},
      f: { titulo: "", fechaCompromiso: "" },
    };
  },
  computed: {
    activas() {
      return (this.plan.tareas || []).filter((t) => t.estatus !== "cancelada");
    },
    // Espejo de accionesDisponibles().agregarTarea: explica qué falta para que
    // el plan llegue al estado donde el desglose tiene sentido. El orden sigue
    // el del flujo, así que el primero que empata es el pendiente más cercano.
    bloqueo() {
      if (this.editable) return "";
      switch (this.plan.estatus) {
        case "pendiente_asignacion":
          return "El plan todavía no está asignado al gerente de su área. Usa «Asignar al gerente del área» en la barra de acciones de abajo; si el área no tiene gerente capturado, hay que registrarlo primero.";
        case "asignado":
        case "pendiente_aceptacion":
          return "El responsable aún no acepta la asignación. Las actividades se capturan después de aceptarla.";
        case "aceptado":
          return "Falta registrar la causa raíz, en la pestaña Resumen. El análisis va antes que el desglose del trabajo.";
        case "en_validacion":
          return "El plan está en validación de CX. Para volver a capturarlas, CX tiene que solicitar correcciones.";
        case "concluido":
        case "cancelado":
          return "El plan ya está cerrado.";
        default:
          return "Solo el responsable del plan o CX pueden capturar actividades.";
      }
    },
  },
  methods: {
    fmtFecha,
    etiquetaTarea: (e) => ETIQUETAS[e] || e,
    cambiar(t, valor) {
      this.$emit("avance-tarea", t.idTarea, Number(valor));
    },
    agregar() {
      if (this.agregando) return;
      const r = validaTarea(this.f);
      this.errores = r.errores;
      if (!r.ok) return;
      this.$emit("agregar-tarea", { ...this.f });
      this.f = { titulo: "", fechaCompromiso: "" };
      this.errores = {};
    },
  },
};
</script>

<style scoped>
.tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: var(--pt-elev);
  border-radius: 12px;
  padding: 14px 16px;
}
.avance-num {
  font-size: 26px;
  font-weight: 800;
  line-height: 1;
}
.avance-lbl {
  font-size: 12px;
  color: var(--pt-dim);
  margin-top: 4px;
}
.avance-track {
  flex: 1;
  max-width: 320px;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--pt-track);
}
.avance-fill {
  height: 100%;
  border-radius: 999px;
  background: #003ca5;
}
.tabla {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.tabla th {
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--pt-muted);
  font-weight: 600;
  padding: 8px 10px;
  border-bottom: 1px solid var(--pt-border);
}
.th-av {
  text-align: right;
}
.tabla td {
  padding: 10px;
  vertical-align: top;
  border-bottom: 1px solid var(--pt-line);
}
.t-titulo {
  font-weight: 500;
}
.t-titulo.hecha {
  text-decoration: line-through;
  color: var(--pt-muted);
}
.t-desc {
  font-size: 12px;
  color: var(--pt-dim);
}
.t-est {
  font-size: 11px;
  color: var(--pt-muted);
  margin-top: 2px;
}
.t-resp,
.t-fecha {
  font-size: 13px;
  color: var(--pt-dim);
  white-space: nowrap;
}
.t-fin {
  font-size: 11px;
  color: #16a34a;
}
.td-av {
  text-align: right;
}
.av-sel {
  font-size: 13px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid var(--pt-border);
  background: var(--pt-card);
  color: var(--pt-text);
  cursor: pointer;
  font-family: inherit;
}
.av-fijo {
  font-size: 13px;
  font-weight: 600;
  color: var(--pt-dim);
}
.vacio {
  font-size: 14px;
  color: var(--pt-muted);
  text-align: center;
  padding: 24px 0;
  margin: 0;
}
.alta {
  border-top: 1px solid var(--pt-border);
  padding-top: 14px;
}
.alta-titulo {
  font-size: 12px;
  font-weight: 700;
  color: var(--pt-dim);
  margin-bottom: 8px;
}
.alta-grid {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  flex-wrap: wrap;
}
.campo-ancho {
  flex: 1;
  min-width: 220px;
}
.field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--pt-dim);
  margin-bottom: 4px;
}
.inp {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid var(--pt-border);
  outline: none;
  background: var(--pt-card);
  color: var(--pt-text);
  box-sizing: border-box;
  font-family: inherit;
}
.inp:focus {
  border-color: #003ca5;
}
.field-error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #b91c1c;
}
.btn-add {
  margin-top: 20px;
  padding: 9px 18px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
}
.btn-add:disabled {
  cursor: not-allowed;
}
.bloqueo {
  margin: 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: var(--pt-elev);
  border-left: 3px solid #d97706;
  font-size: 13px;
  line-height: 1.5;
  color: var(--pt-dim);
}
.bloqueo strong {
  color: var(--pt-text);
}
</style>
